import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimeParts } from '@src/app/core/models/contribution.model';
import { IbGiftCardsContributionService } from '@src/app/features/pages/contribution/services/ib-gift-cards-contribution/ib-gift-cards-contribution.service';

@Component({
    selector: 'ib-gift-cards-contribution-info',
    templateUrl: './ib-gift-cards-contribution-info.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class IbGiftCardsContributionInfoComponent implements OnInit {
    public amount;
    public dateTimeParts: DateTimeParts;
    constructor (
        public contributionService: IbGiftCardsContributionService
    ) {
        this.amount = `${contributionService.contributionDataResponse.amount} ${contributionService.contributionDataResponse.currency.symbol}`.replace('.', contributionService.contributionDataResponse.currency.decimalSeparator).replace(',', contributionService.contributionDataResponse.currency.decimalSeparator);
    }
    ngOnInit (): void {
        this.splitTyme();
    }
    splitTyme = () => {
        const date = this.contributionService.contributionDataResponse.deliveryDate;
        this.dateTimeParts = {
            date: date.split(' ')[0],
            hour: date.split(' ')[1]
        };
    };
}
